var _path, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_on_the_App_Store_Badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.3,
    height: 43.993,
    viewBox: "0 0 153.3 43.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M154.19,40.473a4.41,4.41,0,0,1-4.414,4.41H5.31a4.415,4.415,0,0,1-4.42-4.41V5.306A4.421,4.421,0,0,1,5.31.89H149.775a4.415,4.415,0,0,1,4.414,4.416V40.473Z",
    transform: "translate(-0.89 -0.89)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(13.704 6.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M32.753,20.906a6.674,6.674,0,0,1,3.179-5.6A6.836,6.836,0,0,0,30.548,12.4c-2.265-.238-4.462,1.355-5.615,1.355-1.177,0-2.953-1.332-4.868-1.293a7.168,7.168,0,0,0-6.033,3.68c-2.609,4.517-.663,11.155,1.836,14.806,1.25,1.788,2.712,3.785,4.624,3.714,1.871-.077,2.57-1.193,4.828-1.193,2.237,0,2.893,1.193,4.844,1.148,2.008-.032,3.272-1.8,4.479-3.6a14.775,14.775,0,0,0,2.048-4.172A6.452,6.452,0,0,1,32.753,20.906Z",
    transform: "translate(-12.792 -5.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M27.507,10.925a6.57,6.57,0,0,0,1.5-4.708,6.692,6.692,0,0,0-4.327,2.238A6.252,6.252,0,0,0,23.14,12.99,5.528,5.528,0,0,0,27.507,10.925Z",
    transform: "translate(-11.23 -6.217)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(47.806 19.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M55.346,33.519H52.731l-1.432-4.5H46.32l-1.364,4.5H42.41L47.343,18.2h3.047ZM50.867,27.13l-1.3-4q-.206-.613-.773-2.887h-.046q-.226.978-.728,2.887l-1.272,4Z",
    transform: "translate(-42.41 -17.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M66.061,27.326a6.279,6.279,0,0,1-1.523,4.455,4.454,4.454,0,0,1-3.387,1.455,3.387,3.387,0,0,1-3.138-1.568h-.046v5.82H55.512V25.575q0-1.772-.091-3.637H57.58l.137,1.751h.046a4.368,4.368,0,0,1,6.99-.433A6.087,6.087,0,0,1,66.061,27.326Zm-2.5.09a4.549,4.549,0,0,0-.728-2.66A2.513,2.513,0,0,0,60.7,23.665a2.553,2.553,0,0,0-1.648.6,2.793,2.793,0,0,0-.966,1.581,3.214,3.214,0,0,0-.114.748v1.842a2.952,2.952,0,0,0,.739,2.036,2.45,2.45,0,0,0,1.921.83,2.513,2.513,0,0,0,2.159-1.069A4.7,4.7,0,0,0,63.56,27.416Z",
    transform: "translate(-40.44 -17.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M77.1,27.326a6.274,6.274,0,0,1-1.524,4.455,4.45,4.45,0,0,1-3.386,1.455,3.384,3.384,0,0,1-3.136-1.568H69v5.82H66.55V25.575q0-1.772-.091-3.637h2.159l.137,1.751H68.8a4.369,4.369,0,0,1,6.991-.433A6.1,6.1,0,0,1,77.1,27.326Zm-2.5.09a4.549,4.549,0,0,0-.729-2.66,2.51,2.51,0,0,0-2.136-1.092,2.556,2.556,0,0,0-1.649.6,2.791,2.791,0,0,0-.965,1.581A3.277,3.277,0,0,0,69,26.6v1.842a2.961,2.961,0,0,0,.737,2.036,2.455,2.455,0,0,0,1.923.83,2.513,2.513,0,0,0,2.159-1.069A4.7,4.7,0,0,0,74.6,27.416Z",
    transform: "translate(-38.769 -17.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M89.289,29.251a4.084,4.084,0,0,1-1.361,3.182,6.032,6.032,0,0,1-4.174,1.341,7.306,7.306,0,0,1-3.971-.955l.569-2.046a6.729,6.729,0,0,0,3.549.979,3.355,3.355,0,0,0,2.161-.626,2.045,2.045,0,0,0,.771-1.674,2.134,2.134,0,0,0-.637-1.571A5.919,5.919,0,0,0,84.082,26.7q-4.024-1.5-4.023-4.394a3.888,3.888,0,0,1,1.41-3.1A5.56,5.56,0,0,1,85.221,18a7.437,7.437,0,0,1,3.477.728l-.614,2a6.033,6.033,0,0,0-2.933-.7,2.968,2.968,0,0,0-2.022.637,1.819,1.819,0,0,0-.614,1.387,1.873,1.873,0,0,0,.7,1.5,7.951,7.951,0,0,0,2.229,1.182,7.563,7.563,0,0,1,2.91,1.863A3.892,3.892,0,0,1,89.289,29.251Z",
    transform: "translate(-36.752 -18.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M95.973,24.112H93.267v5.364q0,2.047,1.432,2.046a4.366,4.366,0,0,0,1.09-.114l.068,1.864a5.562,5.562,0,0,1-1.909.272,2.946,2.946,0,0,1-2.274-.887,4.355,4.355,0,0,1-.819-2.979V24.11H89.244V22.268h1.612V20.245l2.411-.728v2.751h2.706v1.845Z",
    transform: "translate(-35.319 -17.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M107.114,27.371a6.061,6.061,0,0,1-1.455,4.183,5.2,5.2,0,0,1-4.048,1.682,4.941,4.941,0,0,1-3.874-1.613,5.875,5.875,0,0,1-1.444-4.069,6,6,0,0,1,1.489-4.2,5.152,5.152,0,0,1,4.011-1.637,5.046,5.046,0,0,1,3.91,1.614A5.808,5.808,0,0,1,107.114,27.371Zm-2.547.079a4.97,4.97,0,0,0-.659-2.622,2.425,2.425,0,0,0-2.2-1.322,2.462,2.462,0,0,0-2.251,1.322A5.065,5.065,0,0,0,98.8,27.5a4.963,4.963,0,0,0,.659,2.621,2.509,2.509,0,0,0,4.433-.023A4.988,4.988,0,0,0,104.567,27.451Z",
    transform: "translate(-34.252 -17.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M113.4,24.1a4.263,4.263,0,0,0-.774-.068,2.319,2.319,0,0,0-2,.979,3.678,3.678,0,0,0-.614,2.182v5.8h-2.454l.023-7.569q0-1.91-.092-3.478h2.138l.09,2.114h.068a3.778,3.778,0,0,1,1.227-1.75,2.968,2.968,0,0,1,1.774-.592,3.941,3.941,0,0,1,.614.045V24.1Z",
    transform: "translate(-32.557 -17.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M123.447,26.942a5.757,5.757,0,0,1-.09,1.113h-7.364a3.206,3.206,0,0,0,1.068,2.5,3.648,3.648,0,0,0,2.409.773,8.145,8.145,0,0,0,2.98-.523l.385,1.7a9.212,9.212,0,0,1-3.7.683,5.366,5.366,0,0,1-4.037-1.512,5.584,5.584,0,0,1-1.466-4.058,6.33,6.33,0,0,1,1.366-4.16,4.7,4.7,0,0,1,3.863-1.772,4.117,4.117,0,0,1,3.617,1.772A5.976,5.976,0,0,1,123.447,26.942Zm-2.341-.637a3.335,3.335,0,0,0-.477-1.887,2.144,2.144,0,0,0-1.956-1.024,2.329,2.329,0,0,0-1.954,1,3.663,3.663,0,0,0-.727,1.909h5.113Z",
    transform: "translate(-31.627 -17.442)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(49.264 6.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M49.864,10.488a3.78,3.78,0,0,1-1.218,3.06,4.845,4.845,0,0,1-3.2.949,14.857,14.857,0,0,1-1.765-.09V7a13.025,13.025,0,0,1,2.078-.157,4.48,4.48,0,0,1,2.982.86A3.476,3.476,0,0,1,49.864,10.488Zm-1.272.033a2.752,2.752,0,0,0-.7-2.022,2.75,2.75,0,0,0-2.039-.7,5.107,5.107,0,0,0-.972.078V13.5a6.371,6.371,0,0,0,.815.033,2.854,2.854,0,0,0,2.138-.77A3.085,3.085,0,0,0,48.591,10.521Z",
    transform: "translate(-43.676 -6.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M55.608,11.4a2.977,2.977,0,0,1-.715,2.055,2.552,2.552,0,0,1-1.988.827,2.426,2.426,0,0,1-1.9-.793,2.889,2.889,0,0,1-.708-2,2.948,2.948,0,0,1,.731-2.066,2.536,2.536,0,0,1,1.971-.8,2.482,2.482,0,0,1,1.922.792A2.866,2.866,0,0,1,55.608,11.4Zm-1.252.039a2.455,2.455,0,0,0-.324-1.288A1.192,1.192,0,0,0,52.951,9.5a1.21,1.21,0,0,0-1.106.649,2.488,2.488,0,0,0-.324,1.31,2.455,2.455,0,0,0,.324,1.288,1.218,1.218,0,0,0,1.095.649,1.2,1.2,0,0,0,1.082-.661A2.439,2.439,0,0,0,54.356,11.442Z",
    transform: "translate(-42.674 -6.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M63.8,8.719l-1.7,5.428H61l-.7-2.357a17.64,17.64,0,0,1-.436-1.754h-.022A12.838,12.838,0,0,1,59.4,11.79l-.747,2.357H57.532l-1.6-5.428h1.24l.614,2.58q.223.915.368,1.742h.022q.135-.68.448-1.731L59.4,8.72h.983l.738,2.535q.268.927.435,1.787h.033a17.074,17.074,0,0,1,.368-1.787l.659-2.535H63.8Z",
    transform: "translate(-41.82 -6.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M68.824,14.162H67.617V11.053q0-1.437-1.094-1.437a1.089,1.089,0,0,0-.872.395,1.4,1.4,0,0,0-.335.93v3.219H64.11V10.285q0-.715-.044-1.553h1.06l.056.849h.033a1.743,1.743,0,0,1,.625-.655,2.039,2.039,0,0,1,1.094-.305,1.732,1.732,0,0,1,1.263.492,2.389,2.389,0,0,1,.625,1.8Z",
    transform: "translate(-40.589 -6.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M71.247,14.474H70.041V6.556h1.206Z",
    transform: "translate(-39.684 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M77.957,11.4a2.977,2.977,0,0,1-.715,2.055,2.554,2.554,0,0,1-1.988.827,2.422,2.422,0,0,1-1.9-.793,2.889,2.889,0,0,1-.708-2,2.948,2.948,0,0,1,.731-2.066,2.535,2.535,0,0,1,1.97-.8,2.485,2.485,0,0,1,1.923.792A2.866,2.866,0,0,1,77.957,11.4Zm-1.253.039a2.455,2.455,0,0,0-.324-1.288A1.19,1.19,0,0,0,75.3,9.5a1.208,1.208,0,0,0-1.106.649,2.488,2.488,0,0,0-.324,1.31,2.455,2.455,0,0,0,.324,1.288,1.218,1.218,0,0,0,1.095.649,1.2,1.2,0,0,0,1.081-.661A2.429,2.429,0,0,0,76.7,11.442Z",
    transform: "translate(-39.291 -6.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M82.916,14.161H81.832l-.09-.625h-.033a1.858,1.858,0,0,1-1.585.748,1.636,1.636,0,0,1-1.239-.492,1.542,1.542,0,0,1-.425-1.105,1.686,1.686,0,0,1,.832-1.519,4.32,4.32,0,0,1,2.341-.514v-.1q0-1.073-1.127-1.072a2.524,2.524,0,0,0-1.415.4l-.245-.792a3.481,3.481,0,0,1,1.862-.469q2.128,0,2.13,2.245v2A8.477,8.477,0,0,0,82.916,14.161ZM81.663,12.3v-.837q-2-.035-2,1.094a.818.818,0,0,0,.231.637.844.844,0,0,0,.59.212,1.219,1.219,0,0,0,.738-.251,1.03,1.03,0,0,0,.438-.854Z",
    transform: "translate(-38.41 -6.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M88.966,14.474H87.9l-.056-.872h-.033a1.8,1.8,0,0,1-1.743.995,2.043,2.043,0,0,1-1.63-.77,3,3,0,0,1-.647-2,3.147,3.147,0,0,1,.7-2.134,2.163,2.163,0,0,1,1.675-.76,1.627,1.627,0,0,1,1.529.737h.023V6.556h1.208v6.456Q88.924,13.8,88.966,14.474Zm-1.25-2.289V11.28a1.777,1.777,0,0,0-.033-.38,1.374,1.374,0,0,0-.436-.731,1.186,1.186,0,0,0-.807-.3,1.238,1.238,0,0,0-1.062.537,2.3,2.3,0,0,0-.387,1.374,2.144,2.144,0,0,0,.371,1.307,1.242,1.242,0,0,0,1.055.535,1.163,1.163,0,0,0,.953-.447A1.487,1.487,0,0,0,87.716,12.185Z",
    transform: "translate(-37.603 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M97.947,11.4a2.977,2.977,0,0,1-.715,2.055,2.55,2.55,0,0,1-1.988.827,2.429,2.429,0,0,1-1.9-.793,2.889,2.889,0,0,1-.708-2,2.948,2.948,0,0,1,.731-2.066,2.537,2.537,0,0,1,1.972-.8,2.48,2.48,0,0,1,1.921.792A2.866,2.866,0,0,1,97.947,11.4Zm-1.25.039a2.455,2.455,0,0,0-.324-1.288A1.193,1.193,0,0,0,95.29,9.5a1.213,1.213,0,0,0-1.106.649,2.488,2.488,0,0,0-.324,1.31,2.455,2.455,0,0,0,.324,1.288,1.233,1.233,0,0,0,2.178-.012A2.45,2.45,0,0,0,96.7,11.442Z",
    transform: "translate(-36.264 -6.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M103.508,14.162H102.3V11.053q0-1.437-1.095-1.437a1.085,1.085,0,0,0-.87.395,1.4,1.4,0,0,0-.335.93v3.219H98.795V10.285q0-.715-.043-1.553h1.059l.056.849H99.9a1.761,1.761,0,0,1,.625-.655,2.043,2.043,0,0,1,1.095-.305,1.731,1.731,0,0,1,1.262.492,2.384,2.384,0,0,1,.625,1.8Z",
    transform: "translate(-35.337 -6.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M110.371,9.8h-1.329v2.637c0,.67.236,1.005.7,1.005a2.125,2.125,0,0,0,.538-.056l.031.915a2.711,2.711,0,0,1-.937.135A1.443,1.443,0,0,1,108.261,14a2.129,2.129,0,0,1-.4-1.463V9.8h-.793V8.9h.793V7.9l1.182-.357V8.9h1.329V9.8Z",
    transform: "translate(-34.079 -6.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M116.1,14.474H114.9V11.388q0-1.459-1.093-1.46a1.152,1.152,0,0,0-1.151.846,1.516,1.516,0,0,0-.056.434v3.264H111.39V6.556H112.6V9.827h.023a1.824,1.824,0,0,1,1.63-.892,1.682,1.682,0,0,1,1.241.492,2.472,2.472,0,0,1,.614,1.82v3.227Z",
    transform: "translate(-33.424 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M121.842,11.192a2.915,2.915,0,0,1-.045.547h-3.619a1.583,1.583,0,0,0,.524,1.229,1.8,1.8,0,0,0,1.185.38,4,4,0,0,0,1.463-.257l.189.838a4.544,4.544,0,0,1-1.822.335,2.631,2.631,0,0,1-1.982-.743,2.736,2.736,0,0,1-.72-1.993,3.106,3.106,0,0,1,.67-2.044,2.308,2.308,0,0,1,1.9-.87,2.019,2.019,0,0,1,1.774.87A2.9,2.9,0,0,1,121.842,11.192Zm-1.151-.312a1.625,1.625,0,0,0-.234-.927,1.054,1.054,0,0,0-.96-.5,1.146,1.146,0,0,0-.96.492,1.827,1.827,0,0,0-.358.938Z",
    transform: "translate(-32.572 -6.244)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.36f6a363d311df19569b5e53d3e6ab6f.svg";
export { ForwardRef as ReactComponent };